import { stripEnPrefix } from "@/utils/locale";

/** 底部导航链接点击（中英文共用） */
export const handleFooterNavClick = (
  e,
  v,
  { navigate, location, isAIServerChild }
) => {
  e.preventDefault();

  if (isAIServerChild) {
    const [path, hash] = v.path.split("#");
    if (hash) {
      navigate(path, { state: { type: v.id, anchor: hash } });
      setTimeout(() => {
        window.location.hash = hash;
      }, 100);
    } else {
      navigate(v.path, { state: { type: v.id } });
    }
    return;
  }

  const [path, hash] = v.path.split("#");
  const currentPath = stripEnPrefix(location.pathname);
  const targetPath = stripEnPrefix(path);
  const isCurrentPage =
    currentPath === targetPath ||
    stripEnPrefix(location.pathname) === stripEnPrefix(v.path);

  if (isCurrentPage) {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document
      .querySelectorAll(
        '[data-scroll-container], .snap-container, [style*="overflow"]'
      )
      .forEach((el) => {
        if (el.scrollTop !== undefined) el.scrollTop = 0;
      });

    if (hash) {
      navigate(path, { state: { type: v.id, anchor: hash }, replace: true });
      setTimeout(() => {
        window.location.hash = hash;
        window.location.reload();
      }, 50);
    } else {
      navigate(path, { state: { type: v.id }, replace: true });
      setTimeout(() => window.location.reload(), 50);
    }
    return;
  }

  if (hash) {
    navigate(path, { state: { type: v.id, anchor: hash } });
    setTimeout(() => {
      window.location.hash = hash;
    }, 100);
  } else {
    navigate(v.path, { state: { type: v.id } });
  }
};
